import { EmailMedium } from '@zoopla-eng/zds/icons';
import { LinkWithIcon } from '@zoopla-eng/zds/link';
import { fontGroups } from '@zoopla-eng/zds/themes';
import React from 'react';
import { contactLinkStyle, contactWrapperStyle } from './contact.styles.css';

type ContactEmailProps = {
    emailUrl?: string;
    onClick?: () => void;
};

const ContactEmail: React.FC<ContactEmailProps> = ({ emailUrl, onClick }) =>
    emailUrl ? (
        <div className={contactWrapperStyle}>
            <div className={`${contactLinkStyle} ${fontGroups.ladle}`}>
                <LinkWithIcon
                    href={emailUrl}
                    onClick={onClick}
                    aria-label="Contact agent"
                    iconPrefix={<EmailMedium />}
                >
                    Email
                </LinkWithIcon>
            </div>
        </div>
    ) : null;

export { ContactEmail };
